import { isAdmin } from "@/user/utils";

const IMPERSONATION_CONTROL_EMAIL_ALLOWLIST = new Set(["wpoerschke@gmail.com"]);

// Takes the signed-in admin's own role and email, not the impersonated user's:
export const canShowImpersonationControl = ({
  role,
  email,
}: {
  role: string | undefined;
  email: string | undefined;
}) =>
  isAdmin(role) &&
  (email?.endsWith("@volca.ai") ||
    IMPERSONATION_CONTROL_EMAIL_ALLOWLIST.has(email ?? ""));
